import { render, staticRenderFns } from "./Fight.vue?vue&type=template&id=622e28ba&scoped=true&"
import script from "./Fight.vue?vue&type=script&lang=js&"
export * from "./Fight.vue?vue&type=script&lang=js&"
import style0 from "./Fight.vue?vue&type=style&index=0&id=622e28ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622e28ba",
  null
  
)

export default component.exports